import React from "react";

const Image = ({ src}) => {;
  return <img src={src} alt="Img" />;
};

export default Image;